<div *ngIf="loading$ | async" class="spinner">
  <mat-spinner></mat-spinner>
</div>

<div class="main__dashboard">
  <mat-tree class="tree__section" *ngIf="dataSource && treeControl" [dataSource]="dataSource"
    [treeControl]="treeControl">
    <!-- This is the tree node template for leaf nodes -->
    <mat-tree-node *matTreeNodeDef="let node" [id]="node?.id">
      <!-- use a disabled button to provide padding for tree leaf -->
      <div *ngIf="node" class="nestedNode expandedRow" [matTooltip]="getDescription(node)">
        <mat-icon><img class="treeImg"
            [src]="isSelected(node) ?  'assets/images/icon-open-folder.svg' : 'assets/images/icon-folder.svg'" />
        </mat-icon>
        <button [routerLink]="folder.id ? ['..',node.id] : [node.id]" mat-icon-button class="treeButton">

          {{getName(node)}}
        </button>
      </div>
    </mat-tree-node>


    <!-- This is the tree node template for expandable nodes -->
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild" [id]="node.id">
      <div class="expandedRow">
        <mat-icon matTreeNodeToggle>
          <img class="treeImg"
            [src]="isSelected(node) ?  'assets/images/icon-open-folder.svg' : (treeControl.isExpanded(node) ? 'assets/images/icon-selected.svg' : 'assets/images/icon-folder.svg')" />
          <!-- [src]="treeControl.isExpanded(node) ? 'assets/images/icon-selected.svg' : 'assets/images/icon-folder.svg'" /> -->
        </mat-icon>
        <button [routerLink]="folder && folder.id ? ['..',node.id] : [node.id]" mat-icon-button
          [attr.aria-label]="'toggle ' + getName(node)" class="treeButton" [matTooltip]="getDescription(node)">

          <!-- icon-open-folder -->
          {{getName(node)}}
        </button>
        <div class="subTree" *ngIf="treeControl.isExpanded(node)" fxLayout="row">
          <ng-container matTreeNodeOutlet></ng-container>
        </div>

      </div>
    </mat-nested-tree-node>
  </mat-tree>
</div>
